import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.66797 7V12.3333C2.66797 12.687 2.80844 13.0261 3.05849 13.2761C3.30854 13.5262 3.64768 13.6667 4.0013 13.6667H12.0013C12.3549 13.6667 12.6941 13.5262 12.9441 13.2761C13.1942 13.0261 13.3346 12.687 13.3346 12.3333V7"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6654 6.33333L7.9987 9L5.33203 6.33333"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.33 2.34H10.33C9.67 2.34 9 2.28 8.5 2.84C7.95 3.4 8 4.2 8 4.67V8.84"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  default: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 10.5V18.5C4 19.0304 4.21071 19.5391 4.58579 19.9142C4.96086 20.2893 5.46957 20.5 6 20.5H18C18.5304 20.5 19.0391 20.2893 19.4142 19.9142C19.7893 19.5391 20 19.0304 20 18.5V10.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 9.5L12 13.5L8 9.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 3.5H15.5C14.5 3.5 13.5 3.42 12.75 4.26C11.93 5.1 12 6.3 12 7V13.25"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.33331 14V24.6667C5.33331 25.3739 5.61426 26.0522 6.11436 26.5523C6.61446 27.0524 7.29274 27.3333 7.99998 27.3333H24C24.7072 27.3333 25.3855 27.0524 25.8856 26.5523C26.3857 26.0522 26.6666 25.3739 26.6666 24.6667V14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3334 12.6667L16 18L10.6667 12.6667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.67 4.67H20.67C19.33 4.67 18 4.56 17 5.67C15.9 6.8 16 8.4 16 9.33V17.67"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

function ImportIcon(props: SvgIconProps) {
  const item = props.fontSize === "large" || props.fontSize === "small" ? size[props.fontSize] : size.default;

  return <SvgIcon {...props}>{item}</SvgIcon>;
}
export default ImportIcon;
